module.exports = __webpack_public_path__ + "img/icon_video_interativo.598aa3b9.png";